import request from '@/utils/request'

export const checkLoginStatus = () => {
  return request.get('/client/user/checkLoginStatus')
}

export const login = (username, password) => {
  return request.post('/login', {
    username,
    password
  })
}

export const logout = () => {
  return request.get('/logout')
}

export const sendCode = (mobile) => {
  return request.get('/sendRegisterSms', {
    params: {
      mobile
    }
  })
}

export const sendForgetCode = (mobile) => {
  return request.get('/client/forget/sendForgetSms', {
    params: {
      mobile
    }
  })
}

export const checkForgetCode = (mobile, code) => {
  return request.post('/client/forget/checkForgetCode', {
    username: mobile,
    code: code
  })
}

export const forgetPwdUpdate = (mobile, code, pwd, pwdAgain) => {
  return request.post('/client/forget/forgetPwdUpdate', {
    username: mobile,
    code: code,
    password: pwd,
    againPassword: pwdAgain
  })
}

export const reg = (mobile, code, pwd, pwdAgain) => {
  return request.post('/register', {
    username: mobile,
    code: code,
    againPassword: pwd,
    password: pwdAgain
  })
}

export const getInterFaceList = () => {
  return request.get('/client/interface/list')
}

export const detailInterface = (id, userId) => {
  return request.get('/client/interface/detail/' + id, {
    params: {
      userId: userId
    }
  })
}

export const applyInterface = (id) => {
  return request.put('/client/userInterface/applyFreeInterface/' + id)
}

export const getUserInterfaceStatis = (startTime, endTime) => {
  return request.get('/client/userInterface/getUserInterfaceStatis', {
    params: {
      startTime,
      endTime
    }
  })
}

export const myApi = () => {
  return request.get('/client/userInterface/myApi')
}

export const applyApiList = () => {
  return request.get('/client/userInterface/applyList')
}

export const updatePwd = (oldPwd, newPwd, againPwd) => {
  return request.post('/client/user/updatePwd', {
    oldPassword: oldPwd,
    newPassword: newPwd,
    againPassword: againPwd
  })
}
